export default __webpack_public_path__ + "static/media/AOT-min.205fe83b.png";